export function parseOddsBoostMessagesAndStatus(settlementStatus, dictionary) {
    const messages = [];
    let status = "Active";
    const isCashedOut = settlementStatus === "CashOut";
    if (isCashedOut) {
        status = "Inactive";
        messages.push({
            type: "CashOut",
            text: dictionary.myBetsDictionary.BonusCashedOutMessage
        });
    }
    return [status, messages];
}
//# sourceMappingURL=parseOddsBoostMessagesAndStatus.js.map